import React from "react"

export const duplicateComponent = (count: number) => (Component: () => JSX.Element) => {
    return new Array<number>(count).fill(0).map((_, i) => React.cloneElement(<Component />, { key: i }))
}
